import React from 'react';
import { ComingSoon } from '@components';

const PhotosPage = () => <ComingSoon subdomain="photos" />;

export default PhotosPage;
